import SVG from 'react-inlinesvg';
import Skeleton from 'react-loading-skeleton';
import getIconClasses from './utilities';

function LazyIcon(props) {
  const classes = getIconClasses(props);

  return (
    <SVG
      {...props}
      src={props.src}
      className={classes}
      style={props.style}
      aria-hidden={true}
      loader={<Skeleton className={`${classes} e-bolt-icon--loading`} circle />}
    />
  );
}

export { LazyIcon };
